// "use client";

// import React, { useEffect } from "react";
// import { useForm, SubmitHandler } from "react-hook-form";
// import { auth } from "../config/firebase";
// import { useNavigate } from "react-router-dom";
// import { Button, TextField, Typography, Grid, Card, Link as MuiLink } from '@mui/material';
// import { createUserWithEmailAndPassword, getRedirectResult, GoogleAuthProvider, OAuthProvider, signInWithRedirect } from "firebase/auth";
// import { useTranslation } from "react-i18next";

// type Inputs = {
//   email: string;
//   password: string;
// };

// const Register = () => {
//   const navigate = useNavigate();
//   const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
//   const { t } = useTranslation(); 
//   const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

//   useEffect(() => {
//     getRedirectResult(auth)
//       .then((result) => {
//         if (result) {
//           navigate("/");
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//         alert("認証中にエラーが発生しました");
//       });
//   }, [navigate]);

//   const onSubmit: SubmitHandler<Inputs> = async (data) => {
//     try {
//       const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);
//       console.log(userCredential);
//       navigate("/settings/login");
//     } catch (error: any) {
//       console.error(error);
//       alert(error.message);
//     }
//   };

//   const googleAuth = () => {
//     const provider = new GoogleAuthProvider();
//     if (googleClientId) {
//       provider.setCustomParameters({ client_id: googleClientId });
//     }
//     signInWithRedirect(auth, provider);
//   };

//   const lineAuth = () => {
//     const provider = new OAuthProvider("oidc.line");
//     signInWithRedirect(auth, provider);
//   };

//   return (
//     <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh', backgroundColor: '#f0f0f0' }}>
//       <Card style={{ padding: '20px', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', width: '100%', maxWidth: '500px' }}>
//         <Grid item xs={12}>
//           <Typography variant="h5" align="center" gutterBottom>
//             {t('register')}
//           </Typography>
          
//           <Button fullWidth variant="outlined" onClick={googleAuth} style={{ marginBottom: '10px' }}>
//             {t('register_with_google')}
//           </Button>

//           {/* <Button fullWidth variant="outlined" onClick={lineAuth} style={{ marginBottom: '20px', backgroundColor: '#06C755', color: 'white' }}>
//             LINEで登録
//           </Button> */}

//           <form onSubmit={handleSubmit(onSubmit)}>
//             <TextField 
//               variant="outlined" 
//               margin="normal" 
//               fullWidth 
//               label={t('email_address')}
//               autoComplete="email"
//               {...register("email", { required: t('email_is_required')})} 
//               error={Boolean(errors.email)}
//               helperText={errors.email?.message}
//             />
//             <TextField 
//               variant="outlined" 
//               margin="normal" 
//               fullWidth 
//               label={t('password')}
//               type="password" 
//               autoComplete="current-password"
//               {...register("password", { required: t('password_is_required'), minLength: { value: 6, message: "パスワードは6文字以上です。" } })} 
//               error={Boolean(errors.password)}
//               helperText={errors.password?.message}
//             />
//             <Button type="submit" fullWidth variant="contained" color="primary" style={{ marginTop: '20px', marginBottom: '20px' }}>
//               {t('register')}
//             </Button>
//           </form>
//           <Grid container justifyContent="flex-end">
//             <Typography variant="body2">
//                {t('already_have_an_account')}<a href="/settings/login" style={{ textDecoration: 'none', color: '#1976d2' }}>{t('go_to_login_page')}</a>
//             </Typography>
//             <Typography variant="body2">
//             {/* <MuiLink href="/rule/privacy-policy" variant="body2"> */}
//           このアプリのGoogle APIから受け取った情報の使用および他のアプリへの転送は、Google APIサービスユーザーデータポリシー、含む利用限定要件に従います。
//           {/* </MuiLink> */}
//           </Typography>
//           </Grid>
//         </Grid>
//       </Card>
//     </Grid>
//   );
// };

// export default Register;
import React, { useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/firebase";
import {
  createUserWithEmailAndPassword,
  getRedirectResult,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithRedirect,
} from "firebase/auth";
import {
  Button,
  TextField,
  Typography,
  Grid,
  Card,
  Link as MuiLink,
} from "@mui/material";
import { useTranslation } from "react-i18next";

type Inputs = {
  email: string;
  password: string;
};

const Register = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
  const { t } = useTranslation();
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useEffect(() => {
    getRedirectResult(auth)
      .then((result) => {
        if (result) {
          navigate("/");
        }
      })
      .catch((error) => {
        console.error(error);
        alert("認証中にエラーが発生しました");
      });
  }, [navigate]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);
      console.log(userCredential);
      navigate("/settings/login");
    } catch (error: any) {
      console.error(error);
      alert(error.message);
    }
  };

  const googleAuth = () => {
    const provider = new GoogleAuthProvider();
    if (googleClientId) {
      provider.setCustomParameters({ client_id: googleClientId });
    }
    signInWithRedirect(auth, provider);
  };

  const lineAuth = () => {
    const provider = new OAuthProvider("oidc.line");
    signInWithRedirect(auth, provider);
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: "100vh", backgroundColor: "#e5e5e5", padding: "24px" }}
    >
      <Card
        style={{
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          backgroundColor: "#ffffff",
          width: "100%",
          maxWidth: "480px",
        }}
      >
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Typography variant="h5" align="center" gutterBottom>
              {t("register")}
            </Typography>
          </Grid>

          <Grid item>
            <Button
              fullWidth
              variant="outlined"
              onClick={googleAuth}
              style={{
                marginBottom: "16px",
                padding: 0,
                border: "none",
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <img
                src="/images/web_dark_rd_SU@3x.png"
                alt="Sign up with Google"
                style={{
                  width: "100%",
                  maxWidth: "320px",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </Button>
          </Grid>

          <Grid item>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TextField
                variant="outlined"
                margin="dense"
                fullWidth
                label={t("email_address")}
                autoComplete="email"
                {...register("email", { required: t("email_is_required") })}
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
              <TextField
                variant="outlined"
                margin="dense"
                fullWidth
                label={t("password")}
                type="password"
                autoComplete="current-password"
                {...register("password", {
                  required: t("password_is_required"),
                  minLength: {
                    value: 6,
                    message: "パスワードは6文字以上です。",
                  },
                })}
                error={Boolean(errors.password)}
                helperText={errors.password?.message}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: "20px" }}
              >
                {t("register")}
              </Button>
            </form>
          </Grid>

          <Grid item>
            <Typography variant="body1">
              {t("already_have_an_account")}
              <MuiLink href="/settings/login" style={{ textDecoration: "none" }}>
                {t("go_to_login_page")}
              </MuiLink>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              このアプリのGoogle APIから受け取った情報の使用および他のアプリへの転送は、
              Google APIサービスユーザーデータポリシー、含む利用限定要件に従います。
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

export default Register;
